import {RegisterType} from '../component-registry';
import {GuidedUiFooterBanner, GuidedUiGenaiBanner} from '../../models/Guided.schema';
import {GuidedBannerGenai} from './guided-banner-genai';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2GenaiBanner {
  @RegisterType(GuidedUiGenaiBanner.type)
  render(inputData: GuidedUiFooterBanner, state: Omit<GuidedV2FactoryState, 'results'>) {

      const {
        text,
        description,
        href,
        buttonText,
        target,
        brand,
      } = inputData; //comes from configuration

      const {
        eventEmitters,
        searchTerm
      } = state;

      const bannerText = state.labelProvider(`guided-v2.banner.text.${text}`,text);
      const bannerDescription = state.labelProvider(`guided-v2.banner.description.${description}`,description);
      const bannerButtonText = state.labelProvider(`guided-v2.banner.buttonText.${buttonText}`,buttonText);

      return <GuidedBannerGenai
        text={bannerText}
        description={bannerDescription}
        buttonText={bannerButtonText}
        eventEmitters={eventEmitters}
        href={href}
        target={target}
        searchTerm={searchTerm}
        brand={brand}
      ></GuidedBannerGenai>;
  };
}
